/* eslint-disable @typescript-eslint/naming-convention */
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonSlides, ModalController, NavController } from '@ionic/angular';
import { FieldInfo } from '../map/map.component';
import { football_fields } from '../../../assets/newFootballFields';
import { MapService } from '../services/map.service';
import { AnalyticsService, TRACK_ACTION } from '../services/analytics.service';
import { SeoService } from '../services/seo.service';
import { RentalRequestModalComponent } from '../rental-request-modal/rental-request-modal.component';

enum FEATURE_NAMES {
  size = 'Размер',
  cover = 'Покрытие',
  roof = 'Накрытие',
  playersCapacity = 'Количество игроков',
  workingSchedule = 'Время работы',
  inventory = 'Инвентарь',
  shower = 'Душ',
  wardrobe = 'Гардероб',
  lighting = 'Освещение',
  parking = 'Паркинг',
  tribunes = 'Трибуны',
  toilet = 'Туалет',
}

@Component({
  selector: 'app-marker-info',
  templateUrl: './marker-info.component.html',
  styleUrls: ['./marker-info.component.scss'],
})
export class MarkerInfoComponent implements OnInit, AfterViewInit {
  @ViewChild('slider') slider: IonSlides;

  fieldInfo: FieldInfo;

  get showRequestButton() {
    return !this.fieldInfo.phone.every((phone) => phone.includes('(044)'));
  }

  get FEATURE_NAMES() {
    return FEATURE_NAMES;
  }

  get football_fields_json() {
    return football_fields;
  }

  slideOpts = {};

  constructor(
    private mapService: MapService,
    private activatedRoute: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private navController: NavController,
    private router: Router,
    private seoService: SeoService,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe((params) => {
      if (params.has('title')) {
        this.fieldInfo = this.football_fields_json.find(
          (field) =>
            field.title.trim().replace(/\ /g, '-') === params.get('title')
        );
      }
    });
  }

  ngAfterViewInit() {
    console.warn(this.fieldInfo);

    this.slideOpts = {
      initialSlide: 0,
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 16,
      preloadImages: false,
    };
    setTimeout(() => {
      if (this.slider) {
        this.slider.update();
      }
    }, 500);

    // SET SEO INFO
    this.seoService.setSeoData(
      this.fieldInfo?.title,
      'Аренда футбольного поля в г. Киев',
      this.fieldInfo?.images[0]
    );
  }

  closeModal() {
    this.navController.navigateBack('map');
  }

  openOnMap() {
    this.trackAction(TRACK_ACTION.SHOW_ON_MAP);

    const { lat, lng } = this.fieldInfo;

    this.router.navigate(['map']);
    this.mapService.showMap();
    setTimeout(() => {
      this.mapService.setZoom(16);
      this.mapService.setCoordinates({ lat, lng });
    }, 200);
  }

  async openRentalRequest() {
    this.trackAction(TRACK_ACTION.OPEN_RENTAL_REQUEST_MODAL);

    const modal = await this.modalController.create({
      component: RentalRequestModalComponent,
      componentProps: { fieldInfo: this.fieldInfo },
    });

    return await modal.present();
  }

  nextSlide() {
    this.slider.slideNext();
  }

  prevSlide() {
    this.slider.slidePrev();
  }

  trackAction(trackAction: TRACK_ACTION) {
    this.analyticsService
      .trackAction(trackAction, this.fieldInfo)
      .subscribe((res) => console.log(res));
  }

  get TRACK_ACTION() {
    return TRACK_ACTION;
  }
}
